const SESSION_IDLE_LIMIT = 1000 * 60 * 30
const LOG_LIMIT = 120

let lastInteractionAt = Date.now()

function compactConsole(method: 'log' | 'warn' | 'error') {
  const original = console[method]
  const buffer: string[] = []

  console[method] = (...args: unknown[]) => {
    try {
      const line = args
        .map(item => typeof item === 'string' ? item : JSON.stringify(item))
        .join(' ')

      buffer.push(line)

      if (buffer.length > LOG_LIMIT) {
        buffer.splice(0, buffer.length - LOG_LIMIT)
      }
    } catch {
      // noop
    }

    original(...args)
  }
}

function installInteractionTracker() {
  const update = () => {
    lastInteractionAt = Date.now()
  }

  window.addEventListener('touchstart', update, { passive: true })
  window.addEventListener('mousedown', update)
  window.addEventListener('keydown', update)
}

function installVisibilityWatchdog() {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return

    const idleTime = Date.now() - lastInteractionAt

    if (idleTime > SESSION_IDLE_LIMIT) {
      window.location.reload()
    }
  })
}

function installMemoryWatchdog() {
  const perf = performance as Performance & {
    memory?: {
      usedJSHeapSize: number
      jsHeapSizeLimit: number
    }
  }

  if (!perf.memory) return

  window.setInterval(() => {
    const usage = perf.memory
    if (!usage) return

    const ratio = usage.usedJSHeapSize / usage.jsHeapSizeLimit

    if (ratio >= 0.92) {
      console.warn('[AgroSchelive] Uso elevado de memoria detectado.')
    }
  }, 60000)
}

export function startRuntimeProtection() {
  compactConsole('log')
  compactConsole('warn')
  compactConsole('error')

  installInteractionTracker()
  installVisibilityWatchdog()
  installMemoryWatchdog()
}
